import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import dayjs from "dayjs";
import { timeAgo } from "%/dynamic-component-editor/helpers/dayjs-helper";

const now = dayjs();
const twoDaysAgo = now.subtract(2, "day").unix();
const inThirtyMinutes = now.add(30, "minute").unix();

const buildDateFormatOptions = () => {
  return [
    {
      value: "global",
      label: "Publication default",
      secondaryLabel: "Uses publication setting",
    },
    {
      value: "timeAgo",
      label: "Relative time",
      secondaryLabel: `${timeAgo(twoDaysAgo)} / ${timeAgo(inThirtyMinutes)}`,
    },
    {
      value: "MMM D, YYYY",
      label: "Date",
      secondaryLabel: now.format("MMM D, YYYY"),
    },
    {
      value: "ddd, MMM D, YYYY",
      label: "Date + weekday",
      secondaryLabel: now.format("ddd, MMM D, YYYY"),
    },
    {
      value: "dddd, MMMM D, YYYY",
      label: "Date + weekday (full)",
      secondaryLabel: now.format("dddd, MMMM D, YYYY"),
    },
    {
      value: "MMM D, YYYY h:mm A",
      label: "Date + time 12h",
      secondaryLabel: now.format("MMM D, YYYY h:mm A"),
    },
    {
      value: "MMM D, YYYY HH:mm",
      label: "Date + time 24h",
      secondaryLabel: now.format("MMM D, YYYY HH:mm"),
    },
    {
      value: "h:mm A",
      label: "Time 12h",
      secondaryLabel: now.format("h:mm A"),
    },
    {
      value: "HH:mm",
      label: "Time 24h",
      secondaryLabel: now.format("HH:mm"),
    },
  ];
};

export default class DateFormat extends BaseOption {
  static DATE_FORMAT_OPTIONS = buildDateFormatOptions();

  static userInterfaceComponent = {
    label: "Date Format",
    component: inspectorTools.AUTOCOMPLETE,
    props: {
      showAllResultsOnClick: true,
      customValueType: "string",
      allowCustomValue: true,
      items: this.DATE_FORMAT_OPTIONS,
    },
  };

  static defaultValue = "global";

  static convertConfigValueToCompiledValue(configValue) {
    return configValue;
  }
}
